import React, { useContext, useEffect, useState } from "react";
import { FetchDataTypes } from "../api/api";
import Cookies from "js-cookie";
import { Line } from "react-chartjs-2";
import { store } from "../App";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler
);

function LineChart({
  chartTitle,
  chartLabel,
  dataValue,
}: {
  chartTitle: string;
  chartLabel: string;
  dataValue: string;
}) {
  const [token, setToken, userId, setUserId] = useContext(store);

  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [labelProp] = useState(chartLabel);
  const [dataProp] = useState(dataValue);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("BalanceHistory", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response.slice(-365));
      });
  }, []);

  const data = {
    labels:
      sectorAllocation &&
      sectorAllocation.map((e: any) => {
        let newDate = e.date;
        return new Date(newDate).toLocaleDateString();
      }),

    datasets: [
      {
        label: "",
        fill: true,
        backgroundColor: "rgb(124,181,236)",
        borderColor: "rgb(124,181,236)",
        data:
          sectorAllocation &&
          sectorAllocation.map((e: any) => {
            const newDataValue = e.marketValue;
            return newDataValue;
          }),
      },
    ],
  };

  return (
    <div className="card w-100">
      <div className="card-header">
        <h5 className="card-title">{chartTitle}</h5>
      </div>
      <div className="card-body">
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink">
              <div className="">
                <Line
                
                  data={data}
                  options={{
                    aspectRatio: 2, // this would be a 1:1 aspect ratio
                    elements: {
                      point: {
                        radius: 1,
                      },
                    },
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      x: {
                        grid: {
                          display: false,
                        },
                      },
                      y: {
                        grid: {
                          display: false,
                        },
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { LineChart };
